export const ADD_RECORD_REQUEST = "ADD_RECORD_REQUEST";
export const ADD_RECORD_SUCCESS = "ADD_RECORD_SUCCESS";
export const ADD_RECORD_FAIL = "ADD_RECORD_FAIL";
export const SAVE_FILLED_RECORD = "SAVE_FILLED_RECORD";

export const RECORD_MINE_LIST_REQUEST = "RECORD_MINE_LIST_REQUEST";
export const RECORD_MINE_LIST_SUCCESS = "RECORD_MINE_LIST_SUCCESS";
export const RECORD_MINE_LIST_FAIL = "RECORD_MINE_LIST_FAIL";

export const RECORD_SUMMARY_REQUEST = "RECORD_SUMMARY_REQUEST";
export const RECORD_SUMMARY_SUCCESS = "RECORD_SUMMARY_SUCCESS";
export const RECORD_SUMMARY_FAIL = "RECORD_SUMMARY_FAIL";

export const RECORD_LIST_REQUEST = "RECORD_LIST_REQUEST";
export const RECORD_LIST_SUCCESS = "RECORD_LIST_SUCCESS";
export const RECORD_LIST_FAIL = "RECORD_LIST_FAIL";

export const ADD_YEARLYREPORT_REQUEST = "ADD_YEARLYREPORT_REQUEST";
export const ADD_YEARLYREPORT_SUCCESS = "ADD_YEARLYREPORT_SUCCESS";
export const ADD_YEARLYREPORT_FAIL = "ADD_YEARLYREPORT_FAIL";
export const SAVE_YEARLYREPORT_RECORD = "SAVE_YEARLYREPORT_RECORD";

export const LIST_YEARLYREPORT_REQUEST = "LIST_YEARLYREPORT_REQUEST";
export const LIST_YEARLYREPORT_SUCCESS = "LIST_YEARLYREPORT_SUCCESS";
export const LIST_YEARLYREPORT_FAIL = "LIST_YEARLYREPORT_FAIL";

export const SEARCH_RECORD_REQUEST = "SEARCH_RECORD_REQUEST";
export const SEARCH_RECORD_SUCCESS = "SEARCH_RECORD_SUCCESS";
export const SEARCH_RECORD_FAIL = "SEARCH_RECORD_FAIL";

export const RECORD_CATEGORY_LIST_REQUEST = "RECORD_CATEGORY_LIST_REQUEST";
export const RECORD_CATEGORY_LIST_SUCCESS = "RECORD_CATEGORY_LIST_SUCCESS";
export const RECORD_CATEGORY_LIST_FAIL = "RECORD_CATEGORY_LIST_FAIL";

export const RECORD_DELETE_REQUEST = "RECORD_DELETE_REQUEST";
export const RECORD_DELETE_SUCCESS = "RECORD_DELETE_SUCCESS";
export const RECORD_DELETE_FAIL = "RECORD_DELETE_FAIL";
export const RECORD_DELETE_RESET = "RECORD_DELETE_RESET";

export const RECORD_DETAILS_REQUEST = "RECORD_DETAILS_REQUEST";
export const RECORD_DETAILS_SUCCESS = "RECORD_DETAILS_SUCCESS";
export const RECORD_DETAILS_FAIL = "RECORD_DETAILS_FAIL";
export const RECORD_UPDATE_REQUEST = "RECORD_UPDATE_REQUEST";
export const RECORD_UPDATE_SUCCESS = "RECORD_UPDATE_SUCCESS";
export const RECORD_UPDATE_FAIL = "RECORD_UPDATE_FAIL";

export const RECORD_UPDATE_RESET = "RECORD_UPDATE_RESET";

export const ADD_CATEGORY_FAIL = "ADD_CATEGORY_FAIL";
export const ADD_CATEGORY_REQUEST = "ADD_CATEGORY_REQUEST";
export const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS";
export const SAVE_FILLED_CATEGORY = "SAVE_FILLED_CATEGORY";
export const CATEGORY_DELETE_RESET = "CATEGORY_DELETE_RESET";
export const CATEGORY_DELETE_REQUEST = "CATEGORY_DELETE_REQUEST";
export const CATEGORY_DELETE_SUCCESS = "CATEGORY_DELETE_SUCCESS";
export const CATEGORY_DELETE_FAIL = "CATEGORY_DELETE_FAIL";

export const ADD_TAXRATE_REQUEST = "ADD_TAXRATE_REQUEST";
export const ADD_TAXRATE_SUCCESS = "ADD_TAXRATE_SUCCESS";
export const ADD_TAXRATE_FAIL = "ADD_TAXRATE_FAIL";
export const SAVE_FILLED_TAXRATE = "SAVE_FILLED_TAXRATE";
export const TAXRATE_DELETE_RESET = "TAXRATE_DELETE_RESET";
export const RECORD_TAXRATE_LIST_REQUEST = "RECORD_TAXRATE_LIST_REQUEST";
export const RECORD_TAXRATE_LIST_SUCCESS = "RECORD_TAXRATE_LIST_SUCCESS";
export const RECORD_TAXRATE_LIST_FAIL = "RECORD_TAXRATE_LIST_FAIL";
export const TAXRATE_DELETE_REQUEST = "TAXRATE_DELETE_REQUEST";
export const TAXRATE_DELETE_SUCCESS = "TAXRATE_DELETE_SUCCESS";
export const TAXRATE_DELETE_FAIL = "TAXRATE_DELETE_FAIL";
export const TAXRATE_UPDATE_REQUEST = "TAXRATE_UPDATE_REQUEST";
export const TAXRATE_UPDATE_SUCCESS = "TAXRATE_UPDATE_SUCCESS";
export const TAXRATE_UPDATE_FAIL = "TAXRATE_UPDATE_FAIL";
export const ONE_TAXRATE_LIST_REQUEST = "ONE_TAXRATE_LIST_REQUEST";
export const ONE_TAXRATE_LIST_SUCCESS = "ONE_TAXRATE_LIST_SUCCESS";
export const ONE_TAXRATE_LIST_FAIL = "ONE_TAXRATE_LIST_FAIL";
export const TAXRATE_UPDATE_RESET = "TAXRATE_UPDATE_RESET";
